import type { CalendarEventReminder } from "../Models/Domain";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { deleteReminder } from "@/Services/TherapyApi/Calendars";

import useCalendarsStore from "../Store";
import useAppStore from "@/Modules/App/Store";

import { danger } from "@/Utils/Debug";

const updateCalendarEventReminder = async (reminder: CalendarEventReminder): Promise<boolean> => {
  const calendarsStore = useCalendarsStore();
  const appStore = useAppStore();

  try {
    await deleteReminder(reminder.uuid);

    calendarsStore.config!.reminders = calendarsStore.config!.reminders.filter(
      (r) => r.uuid !== reminder.uuid
    );

    appStore.showSnackbar({
      type: NotificationType.SUCCESS,
      message: "calendars.menu.config.advice_policy.save_success",
    });

    return true;
  } catch (e) {
    danger("Error updating config", e);

    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "calendars.menu.config.advice_policy.save_error",
    });
  }

  return false;
};

export default updateCalendarEventReminder;
